<template>
  <div v-show="loginState == 'PASSWORD'" >
    <h3  class="mb-3 text-2xl font-bold enter-x"  >登录</h3>
    <a-form :form="form" @submit="handleLogin" class="enter-x"  v-show="loginState == 'PASSWORD'" >
      <a-form-item  class="enter-x">
        <a-input
          placeholder="账号"
          v-decorator="[
            'username',
            {
              rules: [
                {
                  required: true,
                  message: '请输入账号',
                },
              ],
            },
          ]"
          size="large"
          class="fix-auto-fill"
          
        ></a-input>
      </a-form-item>
      <a-form-item  class="enter-x">
        <a-input-password
          placeholder="密码"
          v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: '请输入密码',
                },
              ],
            },
          ]"
          size="large"
          style="width: 100% !important"
        ></a-input-password>
      </a-form-item>
      <a-form-item><PolicyModel></PolicyModel></a-form-item>
      <a-form-item>
        <a-button  type="primary" block size="large" html-type="submit" :loading="login_loading"
          >登录</a-button
        ></a-form-item
      >
    </a-form>
    <div class="mr-4 mb-7 enter-x">
      <a @click="setLoginState('SMS_REGISTRY')" class="float-left">注册</a>
      <a @click="setLoginState('SMS_LOGIN')" class="float-right"> 验证码登入 </a>
    </div>
    <!-- <a-divider class="enter-x">其他登入方式</a-divider>
    <div class="text-center enter-x">
      <a-icon type="wechat" @click="setLoginState('QR_CODE')" :style="{ fontSize: '30px' }" />
    </div> -->
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { loginCheck } from '@/api/user';
  import PolicyModel from '@/components/LoginPolicymodel/index';
  export default {
    components: {
      PolicyModel,
    },
    data() {
      return {
        login_loading: false,
      };
    },

    beforeCreate() {
      this.form = this.$form.createForm(this, { name: 'login' });
    },
    computed: {
      ...mapState('user', ['loginState']),
    },
    methods: {
      setLoginState(type, phone, pwd) {
        this.$store.commit('user/SET_LOGINSTATE', {
          state: type,
          phone: phone ? phone : '',
          pwd: pwd ? pwd : '',
        });
      },
      async handleLogin(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            this.login_loading = true;
            values.token = localStorage.getItem('LOGINSMSTOKEN') || '';
            try {
              console.log(values);
              let res = await loginCheck(values);
              if (res.is_success) {
                values.expire_token = res.token;

                const userInfo = await this.$store.dispatch('user/login', values);
                if (userInfo) {
                  this.$notification.success({
                    message: '登入成功',
                    description: `欢迎回来: ${userInfo.name}`,
                    duration: 3,
                  });
                  this.$router.push(`/admin/contract`);
                }
                this.form.resetFields();
              } else {
                this.setLoginState('SMS_LOGIN', values.username, values.password);
              }
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.login_loading = false;
            }
          }
        });
      },
    },
  };
</script>
<style scoped lang="less">
:deep(.ant-btn.ant-btn-primary) {
      background-color: #0960bd;
    }

</style>